import React from 'react';
import CountrySelectorList from './CountrySelectorList';
import '@stone/scss/components/country-selector/_countryselector.scss';
import { useTranslation } from 'react-i18next';
import Logo from '@stone/ui/logo/Logo';
const CountrySelectorPage = (props) => {
    const regions = JSON.parse(props.regions);
    const { t } = useTranslation();
    if (!regions) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "country-selector--header" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "d-flex justify-center" },
                    React.createElement("div", { id: "countrylogo-wrapper" },
                        React.createElement("div", { className: "header-logo" },
                            React.createElement(Logo, { context: 'country-selector', id: "main", title: '' })))))),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24 col-lg-20 offset-lg-2" },
                    React.createElement("div", { className: "country-selector--page-title" },
                        React.createElement("h2", { className: "font__title" }, t('modal.country.title'))),
                    React.createElement("div", { className: "country-selector--page-content" },
                        React.createElement("p", { className: "inner-col-lg-11 inner-col-xxl-7 country-selector--page-body" }, t('modal.country.description')),
                        React.createElement(CountrySelectorList, { regions: regions })))))));
};
export default CountrySelectorPage;
